export default function guessTimezone() {
    try {
        const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (zone && zone.length > 3) {
            return zone;
        }
    }
    catch (e) {
        // Cannot precisely retrieve timezone!
    }
    return undefined;
}
//# sourceMappingURL=guessTimezone.js.map